import React from "react";
import { getTimeBetweenInSec } from "utils/dateUtils";
import moment from "moment";
import { Icon, Label } from "semantic-ui-react";

const styles = {
	info: { width: "100%", textAlign: "center", color: "darkcyan", fontSize: "0.9em" },
};

const WaitingTimeInfo = ({ creation_date, analyses, t }) => {
	const waitingAnalyses = analyses
		.filter((a) => a.properties.waiting_time_before_sampling > 0)
		.sort((a, b) => b.properties.waiting_time_before_sampling - a.properties.waiting_time_before_sampling); // on veut le plus grand en premier

	const waitingTime = getTimeBetweenInSec(moment(creation_date).add(waitingAnalyses[0].properties.waiting_time_before_sampling, "m")) / 60;
	const timing = Math.floor(Math.abs(waitingTime));
	if (Math.floor(waitingTime) > 0)
		return (
			<Label style={styles.info} color="grey">
				<Icon name="wait" />
				<span>{t("foldersOverview.samplingWaiting", { min: timing })}</span>
			</Label>
		);
	else
		return (
			<Label style={styles.info} color="green">
				<Icon name="play" />
				<span>{t("foldersOverview.samplePatient")}</span>
			</Label>
		);
};

export default WaitingTimeInfo;
